import {
  PAGINATION_TABLE_CURRENT_PAGE_SET,
  PAGINATION_TABLE_INIT,
  PAGINATION_TABLE_PAGE_SIZE_SET,
  PAGINATION_TABLE_TOTAL_SET,
} from 'components/shared/pagination/table/store/action-types';

export function initPagination() {
  return {
    type: PAGINATION_TABLE_INIT,
  };
}

export function setCurrentPage(page = 1) {
  return {
    type: PAGINATION_TABLE_CURRENT_PAGE_SET,
    payload: page,
  };
}

export function setPaginationPageSize(pageSize) {
  return {
    type: PAGINATION_TABLE_PAGE_SIZE_SET,
    payload: pageSize,
  };
}

export function setPaginationTotal(total) {
  return {
    type: PAGINATION_TABLE_TOTAL_SET,
    payload: total,
  };
}



// WEBPACK FOOTER //
// ./src/components/shared/pagination/table/store/actions.js